module.exports = __webpack_public_path__ + "img/map.4a181e13.png";